import React from "react";
import AudioImg from "../assets/img/audio.svg"

interface AudioBtnInput {
    audiostatus: boolean,
    updateAudio: React.Dispatch<React.SetStateAction<boolean>>
    start: Function
    stop: Function
}




export default function AudioBtn(input: AudioBtnInput) {

    function updateState() {
        input.updateAudio(!input.audiostatus)
        if (input.audiostatus) {
            input.stop()
        }
        else {
            input.start()
        }
    }


    return (
        <button
            onClick={updateState}
            style={{ backgroundColor: (input.audiostatus) ? "red" : "" }}>
            <AudioImg width="16px" />
        </button>
    );
}